import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import ShortlistFailureLightbox from './ShortlistFailureLightbox';
import ShortlistDescription from './ShortlistDescription';
import ShortlistRefinement from './ShortlistRefinement';
import ShortlistTable from './ShortlistTable';
import { shortlistStateKey } from '../../helpers/shortlistUtils';
import * as shortlistActions from '../../actions/shortlist';
import * as expandableRowActions from '../../actions/expandableRow';
import { actions as tableActions } from '../../modules/DataTable';

class MyShortlist extends PureComponent {
    static propTypes = {
        applyDefaultShortlistRefinement: PropTypes.func.isRequired,
        updateShortlistTable: PropTypes.func.isRequired,
        updateShortlistTableIfNeeded: PropTypes.func.isRequired,
        clearData: PropTypes.func.isRequired,
        hideRow: PropTypes.func.isRequired,
        openShortlistFailureLightbox: PropTypes.func,
    };

    componentDidMount() {
        this.props.updateShortlistTableIfNeeded();
    }

    componentWillUnmount() {
        this.props.applyDefaultShortlistRefinement();
        this.props.clearData(shortlistStateKey);
        this.props.hideRow(shortlistStateKey);
    }

    componentWillReceiveProps(nextProps) {
        const oldRefinement = this.props.refinement;
        const newRefinement = nextProps.refinement;
        const failure = nextProps.dataTable.failure;

        if (oldRefinement !== newRefinement) {
            this.props.updateShortlistTable();
        }

        if (failure) {
            this.props.openShortlistFailureLightbox();
        }
    }

    render() {
        return (
            <div>
                <ShortlistFailureLightbox />
                <ShortlistDescription />
                <ShortlistRefinement />
                <ShortlistTable />
            </div>
        );
    }
}

function mapStateToProps(state) {
    const {
        refinement,
        dataTable,
        pager,
        expandableRow: {
            expandedRow
        },
    } = state[shortlistStateKey];
    return {
        refinement,
        dataTable,
        pager,
        expandedRow,
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        ...shortlistActions,
        ...expandableRowActions,
        ...tableActions,
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(MyShortlist);



// WEBPACK FOOTER //
// ./src/js/containers/Shortlist/index.js